












import { Component } from "vue-property-decorator";
import TooltipIcon from "@share/common/TooltipIcon.vue";
import { DropdownBase } from "./dropdown-base";
@Component({ components: { TooltipIcon } })

export default class DropdownList extends DropdownBase {

  opened = true;

}

